import { translations } from '@wix/premium-fed-sdk/@premium-essentials';
import { MY_DOMAINS_SHARED_COMPONENTS_TRANSLATIONS_NS, resourceLoader, } from '../assets/resourceLoader';
import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
export const { TranslationsProvider, useTranslations: useTranslation } = translations.createTranslations(resourceLoader, MY_DOMAINS_SHARED_COMPONENTS_TRANSLATIONS_NS);
export const DomainsSharedTranslationsExtension = createModuleExtension({
    extensionName: 'DomainsSharedTranslations',
    internals: { useTranslation },
    Provider: TranslationsProvider,
});
//# sourceMappingURL=translations.js.map